export const scrollToPosition = (left: number, top: number, behavior: ScrollBehavior = "smooth") => {
  const mainLayout = document.getElementById("mainLayout");
  if (mainLayout) {
    try {
      mainLayout.scroll({ left, top, behavior });
    } catch (err) {
      mainLayout.scrollTop = top;
      mainLayout.scrollLeft = left;
    }
  }
};
